import { Route, Routes } from "react-router-dom";
import HeaderBase from "./HeaderBase";

const Header = () => {

    return (

        <Routes>
            <Route  path='/profile' element={<HeaderBase  />} />
            <Route  path='/my-products' element={<HeaderBase  />} />
            <Route  path='/products' element={<HeaderBase  />} />
            <Route  path='/orders' element={<HeaderBase  />} />
            <Route  path='/orders/:uniqueCode' element={<HeaderBase  />} />

            <Route  path='/trans' element={<HeaderBase  />} />
            <Route  path='/trans/add' element={<HeaderBase  />} />
            <Route  path='/accumulative' element={<HeaderBase  />} />
            <Route  path='/settlements' element={<HeaderBase  />} />
            <Route  path='/installments/factors' element={<HeaderBase  />} />
            <Route  path='/authentication' element={<HeaderBase  />} />
        </Routes>

    );
}

export default Header;